import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getCestaLineasEnAPI, eliminarCestaLineasEnAPI, setCestaLineasEnAPI, vaciarCestaLineasEnAPI, getClienteTallerEnAPI, setClienteTallerEnAPI, GetClientesERPSocioEnAPI, ObtenerTallerEnAPI, ObtenerClientesSocioEnAPI } from "../../action/actionCreatorsRequests"
import { traducirPagina, referenciaActualSelect, convertirMoneda, redondeo, MSGOK, obtenerDatosUsuarioYLicenciaActual, MSGERROR, efectoRemoveBuscadorReferencia, obtenerUsuario } from '../../librerias/funciones'
import { MDBCol, MDBTable, MDBTableHead, MDBTableBody, MDBBtn, MDBInput } from 'mdbreact';
import FichaMasiva from '../FichaMasiva';
import FichaMantenimientoCliente from '../MantenimientoClienteTaller'


import {
    PlusOutlined,
    CloseOutlined,
    SearchOutlined,
    CloudUploadOutlined
} from '@ant-design/icons';

import { Select, Card, Modal, Button, Input, Row, Col, Drawer } from 'antd';

const { Option } = Select;
const ListadoClientes = ({ props, configApp, openDrawerFichaClienteSocio, clienteTallerSeleccionado, openDrawerFichaMantenimientoCliente }) => {
    const [abrirFichaClienteTaller, setAbrirFichaClienteTaller] = React.useState(false);
    const [mostrarBotones, setMostrarBotones] = React.useState([]);

    const [abrirFichaMasiva, setAbrirFichaMasiva] = React.useState(false);
    const [hayClientes, setHayClientes] = React.useState(false);
    const [clientesTaller, setClientesTaller] = React.useState([]);
    const [obtenerClientesAux, setObtenerClientesAux] = React.useState([]);
    const [textoFiltroCliente, setTextoFiltroCliente] = React.useState("");
    const [sociosLocal, setSociosLocal] = React.useState([]);
    const [clienteSeleccionado, setClienteSeleccionado] = React.useState({});
    const [idSocioLocal, setIdSocioLocal] = React.useState(0);



    const BuscarClientes = (REGSPAGE, PAGE, ORDERCOLUM, ORDERDIR, ID_SOCIO) => {
        setHayClientes(true);
        //ObtenerTallerEnAPI
        ObtenerClientesSocioEnAPI(ID_SOCIO).then((cli) => {
            if (cli !== undefined) {
                if (cli !== null && cli.length > 0) {
                    setClientesTaller(cli)
                    setObtenerClientesAux(cli)
                } else {
                    setClientesTaller(null)
                    setObtenerClientesAux(null)

                }
            }
        })
    }

    const actualizarTabla = () => {
        BuscarClientes(10000, 1, 1, "D", props.ID_SOCIO);

    }



    if (!hayClientes && props.ABRIR_FICHA) {
        setHayClientes(true);

        BuscarClientes(10000, 1, 1, "D", props.ID_SOCIO);

        let LISTA_SOCIOS = obtenerUsuario().SOCIOS;
        if (LISTA_SOCIOS !== undefined && LISTA_SOCIOS !== null) {
            let REGISTRO = LISTA_SOCIOS.find((registro) => registro.ID_SOCIO === props.ID_SOCIO)
            if (REGISTRO !== undefined) {
                if (REGISTRO.CONECTADO)
                    setMostrarBotones(REGISTRO.CONECTADO ? false : true)
            } else {
                setMostrarBotones(false)
            }
        }



    } else {
        if (!props.ABRIR_FICHA && hayClientes) {


            setIdSocioLocal(0)
            setClienteSeleccionado({})
            setSociosLocal([])
            setTextoFiltroCliente("")
            setHayClientes(false);
            setClientesTaller([])
            setObtenerClientesAux([])
        }
    }




    const formatoCadena = (CADENA) => {
        return CADENA = CADENA === undefined || CADENA === null ? "" : CADENA;
    }

    const buscarCliente = (palabra, listaCliente) => {
        let clientesEncontrado = [];
        if (palabra !== "") {
            if (listaCliente !== null) {


                let resultadoFiltro = listaCliente.filter((cliente) => {
                    return formatoCadena(cliente.Codigo).toString().toUpperCase().includes(palabra.toUpperCase()) ||
                        formatoCadena(cliente.Razon).toUpperCase().includes(palabra.toUpperCase()) ||
                        formatoCadena(cliente.Cif).toUpperCase().includes(palabra.toUpperCase()) ||

                        formatoCadena(cliente.Poblacion).toUpperCase().includes(palabra.toUpperCase()) ||
                        formatoCadena(cliente.Telefono).toUpperCase().includes(palabra.toUpperCase())

                })

                if (resultadoFiltro.length > 0) {
                    clientesEncontrado = resultadoFiltro;
                } else {
                    clientesEncontrado = [];
                }
            }


            if (clientesEncontrado.length > 0) {
                setClientesTaller(clientesEncontrado);
            } else {
                setClientesTaller(null);
            }
        } else {
            setClientesTaller(obtenerClientesAux);
        }
    }



    return (
        <div>

            <Drawer
                width={1300}
                onClose={() => { props.ACTUALIZAR_FICHA(false) }}
                visible={props.ABRIR_FICHA}
                closable={false}
                placement={"right"}
                bodyStyle={{ padding: '0px' }}
                style={{ zIndex: '999', color: '#fff' }}>


                <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => { props.ACTUALIZAR_FICHA(false) }}></CloseOutlined >
                        <div> {props.title}</div>
                    </div>

                    <div className='itemHeaderDrawer2'>

                    </div>
                </div>



                <div className="p-3" style={{ height: (configApp.height - 70).toString() + "px", overflowX: 'hidden', overflowY: 'auto' }}>
                    <div className="flex-container mdb-skin">
                        <div style={{ flexGrow: '6', textAlign: 'left' }}>
                            <div className="grid-container mb-3" style={{ backgroundColor: '#eee' }}>
                                <div className="grid-item">
                                    <input id="buscadorClienteTaller" className="form-control" type="text" aria-label="Search" placeholder={traducirPagina("Buscar_taller")} style={{ backgroundColor: "transparent", width: '400px', border: '0px', height: '100%', color: '#000' }} name="txtInputCliente" autoComplete="off" value={textoFiltroCliente} onChange={(e) => { setTextoFiltroCliente(e.target.value); buscarCliente(e.target.value, obtenerClientesAux) }} />
                                </div>

                                <div className="grid-item" >
                                    <MDBBtn id="closeBuscadorClienteTaller" onClick={e => { efectoRemoveBuscadorReferencia("buscadorCliente", true); }} style={{ border: '0', padding: '6px 5px 5px 7px', margin: '0', boxShadown: 'none', visibility: 'hidden' }} className="btn-matriculav2">  <CloseOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </MDBBtn>
                                </div>

                                <div className="grid-item barraLateral" ></div>

                                <div className="grid-item">
                                    <MDBBtn onClick={e => { }} style={{ border: '0', padding: '6px 1px 5px 7px', margin: '0', boxShadown: 'none' }} className="btn-matricula">  <SearchOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </MDBBtn>
                                </div>
                            </div>
                        </div>


                        {mostrarBotones ?
                            <>
                                <div >
                                    <button style={{ height: '40px', width: '150px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', marginLeft: '10px', color: '#1890ff', backgroundColor: 'efefef', cursor: 'pointer' }} onClick={() => {
                                        setAbrirFichaMasiva(true)
                                    }

                                    }><CloudUploadOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Masiva")} </span>  </button>
                                </div>


                                <div >
                                    <button style={{ height: '40px', width: '180px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', marginLeft: '10px', color: '#1890ff', backgroundColor: '#efefef', cursor: 'pointer' }} onClick={() => {
                                        setClienteSeleccionado({});
                                        setAbrirFichaClienteTaller(true)
                                    }

                                    }><PlusOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Nuevo_Cliente")} </span>  </button>
                                </div>
                            </>
                            :
                            null
                        }
                    </div>

                    <Card style={{ height: (configApp.height - 170).toString() + "px" }} className="mb-2 mdb-skin" >
                        {clientesTaller === null ?
                            <div style={{ textAlign: 'center' }}>
                                <h4>{traducirPagina("Sin_registros")}</h4>
                            </div>
                            :
                            clientesTaller.length > 0 ?
                                <div style={{ fontSize: '16px', fontWeight: '500', color: "#000", height: (configApp.height - 225).toString() + "px", overflowX: 'hidden', overflowY: 'auto' }} className="row">
                                    <MDBTable responsive hover >
                                        <MDBTableHead>
                                            <tr>
                                                <th style={{ paddingLeft: 0, fontSize: "14px", fontWeight: "bold", width: '110px', verticalAlign: 'baseline', cursor: 'pointer' }} >
                                                    {traducirPagina("Codigo")}
                                                </th>
                                                <th style={{ paddingLeft: 0, fontSize: "14px", fontWeight: "bold", verticalAlign: 'baseline', cursor: 'pointer' }} >{traducirPagina("Razon")}  </th>
                                                <th style={{ paddingLeft: 0, fontSize: "14px", fontWeight: "bold", width: '110px', verticalAlign: 'baseline', cursor: 'pointer' }}>{"CIF"} </th>
                                                <th style={{ paddingLeft: 0, fontSize: "14px", fontWeight: "bold", width: '240px', verticalAlign: 'baseline' }}>{traducirPagina("Poblacion")}</th>
                                                <th style={{ paddingLeft: 0, fontSize: "14px", fontWeight: "bold", width: '200px', verticalAlign: 'baseline' }}>{traducirPagina("Telefono")}</th>
                                            </tr>
                                        </MDBTableHead>
                                        <MDBTableBody>
                                            {clientesTaller.map((cliente, i) =>
                                                <tr key={cliente.Codigo} onClick={(e) => {
                                                    //props.CLIENTE_SELECT(cliente)
                                                    props.DATOS_CLIENTE_SELECCIONADO(cliente)
                                                    props.ABRIR_FICHA_MANTENIMIENTO(true)
                                                    props.ACTUALIZAR_FICHA(false)
                                                }}>
                                                    <td style={{ paddingLeft: 0, fontSize: "14px", verticalAlign: 'middle' }}>{cliente.Codigo}</td>
                                                    <td style={{ paddingLeft: 0, fontSize: "14px", verticalAlign: 'middle' }}>{cliente.Razon}</td>
                                                    <td style={{ paddingLeft: 0, fontSize: "14px", verticalAlign: 'middle' }}>{cliente.Cif}</td>
                                                    <td style={{ paddingLeft: 0, fontSize: "14px", verticalAlign: 'middle' }}>{cliente.Poblacion}</td>
                                                    <td style={{ paddingLeft: 0, fontSize: "14px", verticalAlign: 'middle' }}>{cliente.Telefono}</td>

                                                </tr>
                                            )}
                                        </MDBTableBody>
                                    </MDBTable>
                                </div>

                                :
                                <div style={{ fontSize: '16px', fontWeight: '500', color: "#000" }} className="row">
                                    <MDBCol md="9">
                                        <div>
                                            <span className="skeleton-box" style={{ width: '900px' }}></span>
                                            <br />
                                            <span className="skeleton-box" style={{ width: '900px' }}></span>
                                            <br />
                                            <span className="skeleton-box" style={{ width: '800px' }}></span>
                                            <br />
                                            <span className="skeleton-box" style={{ width: '800px' }}></span>
                                            <br />
                                            <span className="skeleton-box" style={{ width: '800px' }}></span>
                                            <br />
                                            <span className="skeleton-box" style={{ width: '800px' }}></span>
                                        </div>
                                    </MDBCol>
                                </div>
                        }
                    </Card>
                </div>
            </Drawer>

            {abrirFichaClienteTaller ?
                <FichaMantenimientoCliente
                    ABRIR_FICHA={abrirFichaClienteTaller}
                    CERRAR_FICHA={setAbrirFichaClienteTaller}

                    CLIENTE_SELECCIONADO={clienteSeleccionado}
                    ACTUALIZAR_CLIENTES={null}
                    ID_SOCIO={props.ID_SOCIO}
                    ACTUALIZAR_SECUNDARIO={actualizarTabla}
                > </FichaMantenimientoCliente>
                :
                null
            }



            {abrirFichaMasiva ?
                <FichaMasiva
                    title={traducirPagina("titulo_masiva")}
                    ABRIR_FICHA={abrirFichaMasiva}
                    ACTUALIZAR_MASIVA={setAbrirFichaMasiva}
                    ID_SOCIO={props.ID_SOCIO}
                    ACTUALIZAR_CLIENTES={null}
                    ACTUALIZAR_SECUNDARIO={actualizarTabla}

                ></FichaMasiva>
                :
                null
            }

        </div>
    )
}

ListadoClientes.propTypes = {
    title: PropTypes.string,
    ID_SOCIO: PropTypes.number,
    ABRIR_FICHA: PropTypes.bool,
    ACTUALIZAR_FICHA: PropTypes.func,
    CLIENTE_SELECT: PropTypes.func,
    ABRIR_FICHA_MANTENIMIENTO: PropTypes.func,
    DATOS_CLIENTE_SELECCIONADO: PropTypes.func,
};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        configApp: state.configApp,
        openDrawerFichaClienteSocio: state.estadoDrawer.openDrawerFichaClienteSocio,
        clienteTallerSeleccionado: state.clienteTallerSeleccionado,
        openDrawerFichaMantenimientoCliente: state.estadoDrawer.openDrawerFichaMantenimientoCliente,

    };
}

export default connect(mapStateToProps)(ListadoClientes);